// 电池详情
export default {
    owner: 'Owner',
    phone: 'Phone',
    aircraftNumber: 'Aircraft Number',
    chargerNumber: 'Charger Number',
    reportingTime: 'Reporting Time',
    TUT: 'Total Usage Time',
    TOC: 'Number Of Cycles',
    ODT: 'Over Discharge Times',
    BLS: 'Battery Life Statistics',
    residualLife: 'Residual Life',
}